export default "__VITE_ASSET__YiefWHn9__"